import SectionHeading from "../../SectionHeading";
import { logoRegistry } from "../../../../assets/logoRegistry";
import { siteSections } from "../../../../content/siteSections";

/**
 * Team credibility section with marquee logos.
 * Translation: Team credibility section with marquee logos.
 *
 * @returns {JSX.Element} About section.
 */
const About = () => {
  const marqueeLogos = [...siteSections.about.logos, ...siteSections.about.logos];

  return (
    <section id="about" className="section-block">
      <div className="section-shell">
        <SectionHeading
          eyebrow={siteSections.about.eyebrow}
          title={siteSections.about.title}
          description={siteSections.about.description}
        />

        <div className="logo-slider-container">
          <div className="logo-marquee">
            {marqueeLogos.map((logo, index) => (
              <div key={`${logo.key}-${index}`} className="logo-item">
                <img
                  src={logoRegistry[logo.key].src}
                  className="logo-item__image"
                  alt={logoRegistry[logo.key].alt}
                  title={`Experience with ${logoRegistry[logo.key].alt}`}
                  width="640"
                  height="320"
                  style={{
                    "--logo-mobile-height": `${logoRegistry[logo.key].mobileHeight}px`,
                    "--logo-desktop-height": `${logoRegistry[logo.key].desktopHeight}px`,
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
